import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const getTopicDetailsByProgramID = (ID) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_TOPIC_DETAILS_BY_PROGRAM_ID(ID)
  );
};

export default getTopicDetailsByProgramID;
